<script>
import PouchDB from 'pouchdb'
import PouchDBFind from 'pouchdb-find'
import PouchDBAuth from 'pouchdb-authentication'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      metadata: {},
      db: {},
      pendingMax: 0,
      batch_size: 1000,
      dbconfig: new PouchDB('config'),
      msg: null
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  mounted () {
    PouchDB.plugin(PouchDBFind)
    PouchDB.plugin(PouchDBAuth)
    this.loadMetadata()
  },
  watch: {
    $route (to, from) {
      this.loadMetadata()
    },
    user (to, from) {
      if (to && !from) {
        this.loadMetadata()
      }
    }
  },
  methods: {
    ...mapActions([
      'update_metadata',
      'update_db',
      'get_db',
      'setMessage'
    ]),
    readyMethod () {
      return null
    },
    loadMetadata () {
      let obj = this
      let promise = null
      if (this.$route.params.json === 'inspection') {
        promise = import('../configuration/json/inspection.json')
      }
      if (this.$route.params.json === 'rdio') {
        promise = import('../configuration/json/rdio.json')
      }
      if (this.$route.params.json === 'catodico') {
        promise = import('../configuration/json/catodico.json')
      }
      if (this.$route.params.json === 'catodico_patrullaje') {
        promise = import('../configuration/json/catodico_patrullaje.json')
      }
      if (promise) {
        promise.then(metadata => {
          obj.metadata = metadata.default
          // this.$set(obj.$root, 'metadata', metadata)
          this.update_metadata(metadata)
          return this.get_db().then(function (db) {
            obj.db = db
            obj.msg = null
          }).catch(function (err) {
            obj.db = null
            console.log(err)
            obj.msg = err.toString()
            obj.setMessage('loadMetadata: ' + JSON.stringify(err))
          })
        }).then(function () {
          obj.readyMethod()
        })
      }
    },
    savedata (id, data) {
      var obj = this
      data['_id'] = String(id)
      /* if (this.$route.params.typex === 'server') {
        data['username'] = obj.username
      } */
      return this.db.put(data, function callback (err, result) {
        if (!err) {
          console.log('Successfully saved!')
        } else {
          console.log(err)
          obj.setMessage('savedata: ' + JSON.stringify(err))
        }
      })
    },
    listdata () {
      var obj = this
      return this.db.allDocs({ include_docs: true, descending: true }).then(function (data) {
        return data.rows.map(a => a.doc)
      }).catch(err => {
        console.log(err)
        obj.setMessage('listdata: ' + JSON.stringify(err))
      })
    },
    deletedata (data) {
      data._deleted = true
      return this.db.put(data)
    },
    getdata (id, attachments = false) {
      if (attachments) {
        return this.db.get(id, { attachments: true, binary: true })
      } else {
        return this.db.get(id)
      }
    },
    replicate (elem) {
      let obj = this
      return this.get_db({ typex: 'server' }).then(function (db) {
        var dbremote = db
        // var d1 = new Date()
        // var val = d1.getTime()
        // var d = new Date(parseInt(val) - d1.getTimezoneOffset() * 60000)
        /* var d = d1
        d = d.toISOString()
        d = d.substr(0, 10) + ' ' + d.substr(11, 5)
        elem['sync_date'] = d */
        elem['username'] = obj.user.name

        return obj.db.put(elem).then(function (response) {
          // console.log(response)
          elem._rev = response.rev
          return obj.db.replicate.to(dbremote, {
            doc_ids: [elem._id]
          }).then(function (msg) {
            if (msg.errors && msg.errors.length) {
              obj.msg = msg.errors[0].message
              console.log(msg)
              obj.setMessage('replicate: ' + obj.msg)
            } else {
              elem['synced'] = true
              return obj.db.put(elem).then(function () {
                obj.msg = null
              }).catch(function (err) {
                console.log(err)
                obj.msg = err.toString()
                obj.setMessage('replicate: ' + JSON.stringify(err))
              })
            }
          }).catch(function (err) {
            console.log(err)
            obj.msg = err.toString()
            obj.setMessage('replicate: ' + JSON.stringify(err))
          })
        }).catch(function (err) {
          console.log(err)
          obj.msg = err.toString()
          obj.setMessage('replicate: ' + JSON.stringify(err))
        })
      }).catch(function (err) {
        console.log(err)
        obj.msg = err.toString()
        obj.setMessage('replicate: ' + JSON.stringify(err))
        throw err
      })
    }
  }
}
</script>
